import React, { useState } from 'react';
import { Box, CardContent, Typography, TextField, InputAdornment, Button } from '@mui/material';
import { HealthAndSafety, Search, Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { PageContainer, PageCard, SectionHeader } from '../../common/components/styled-ui-elements';
import { BackToDashboardButton } from '../../common/components/navigation';
import { ComplianceGrid, SeedComplianceItemsButton } from '../components/ComplianceList';

/**
 * ComplianceDashboard - Main page component for the compliance requirements dashboard
 * Lists every requirement, color-coded by status, with search and filters
 */
const ComplianceDashboard: React.FC = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');

  return (
    <PageContainer sx={{ backgroundColor: '#f8fafc' }}>
      <Box display="flex" justifyContent="center">
        <PageCard>
          <Box sx={{
            backgroundColor: '#ffffff',
            borderBottom: '2px solid #3b82f6',
            p: 2.5
          }}>
            <Box display="flex" justifyContent="space-between" alignItems="flex-start">
              <Box>
                <SectionHeader
                  icon={<HealthAndSafety sx={{ mr: 1, color: '#d97706' }} />}
                  title="Compliance Management"
                />
                <Typography
                  variant="body2"
                  sx={{ color: '#64748b', ml: 4 }}
                >
                  Track regulatory compliance requirements across every facility
                </Typography>
              </Box>
              <Box display="flex" gap={1}>
                <SeedComplianceItemsButton />
                <Button
                  variant="contained"
                  startIcon={<Add />}
                  onClick={() => navigate('/compliance/create')}
                  sx={{
                    backgroundColor: '#162346',
                    '&:hover': { backgroundColor: '#1a2a52' },
                    fontWeight: 600,
                    textTransform: 'none',
                    px: 2.5,
                  }}
                >
                  Create Requirement
                </Button>
                <BackToDashboardButton />
              </Box>
            </Box>
          </Box>

          <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
            <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
              <TextField
                size="small"
                placeholder="Search by title, type, center, status, accreditation body..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ flex: 1, maxWidth: 500 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search sx={{ color: '#94a3b8' }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>

            <ComplianceGrid searchText={searchText} />
          </CardContent>
        </PageCard>
      </Box>
    </PageContainer>
  );
};

export default ComplianceDashboard;
